import { render } from "./AddDefaultMessage.vue?vue&type=template&id=dc14fcca&scoped=true"
import script from "./AddDefaultMessage.vue?vue&type=script&lang=js"
export * from "./AddDefaultMessage.vue?vue&type=script&lang=js"

import "./AddDefaultMessage.vue?vue&type=style&index=0&id=dc14fcca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc14fcca"]])

export default __exports__